import { render } from "./HotelPageView.vue?vue&type=template&id=ebe0d6ae"
import script from "./HotelPageView.vue?vue&type=script&lang=js"
export * from "./HotelPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__